export enum PrizeType {
  GELDGEWINN = 1,
  SACHGEWINN = 2,
}

export const PrizeTypeLabel: Record<PrizeType, string> = {
  [PrizeType.GELDGEWINN]: 'Geldgewinn',
  [PrizeType.SACHGEWINN]: 'Sachgewinn',
};

export interface IPrize {
  id: number;
  drawingBaseId: number;
  typ: PrizeType;
  value: string;
  title: string;
  description: string;
  sort: number;
}

export interface IPrizeUpload {
  id: number;
  prizeId: number;
  url: string;
}
